import React, { useState } from "react";
import { Tooltip } from "@mui/material";
import {
    SDivider,
    SLink,
    SLinkContainer,
    SLinkIcon,
    SLinkLabel,
    SLinkNotification,
    SLogo,
    SSidebar,
    SSidebarButton,
} from "./styles";

import logoMediumInv from "../../assets/logo_medium_inv.png";

import {
    AiOutlineHome,
    AiOutlineLeft,
    AiOutlineSetting,
    AiOutlineTrophy
} from "react-icons/ai";
import { FaRegNewspaper, FaFacebook, FaInstagram } from "react-icons/fa";
import { MdLogout, MdLogin, MdSchool } from "react-icons/md";
import { GoGraph } from "react-icons/go";

// import { ThemeContext } from "./../../App";
import { useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useUser } from "../../context/UserContext";

const Sidebar = () => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const { pathname } = useLocation();

    return (
        <SSidebar isOpen={sidebarOpen}>
            <>
                <SSidebarButton isOpen={sidebarOpen} onClick={() => setSidebarOpen((p) => !p)}>
                    <AiOutlineLeft />
                </SSidebarButton>
            </>
            <SLogo isOpen={sidebarOpen}>
                <img src={logoMediumInv} alt="logo" />
            </SLogo>
            <SDivider />
            {linksArray.map(({ icon, label, notification, to, disabled }) => {
                const linkContent = (
                    <SLink
                        to={disabled ? "#" : to}
                        style={{
                            ...(!sidebarOpen ? { width: `fit-content` } : {}),
                            ...(disabled ? { pointerEvents: 'none' } : {})
                        }}
                    >
                        <SLinkIcon>{icon}</SLinkIcon>
                        {sidebarOpen && (
                            <>
                                <SLinkLabel>{label}</SLinkLabel>
                                {!!notification && (
                                    <SLinkNotification>{notification}</SLinkNotification>
                                )}
                            </>
                        )}
                    </SLink>
                );
                return (
                    <SLinkContainer key={label} isActive={pathname === to} style={disabled ? { opacity: 0.5 } : {}}>
                        {disabled ? (
                            <Tooltip title="Próximamente" placement="right">
                                <div style={{ cursor: 'not-allowed' }}>{linkContent}</div>
                            </Tooltip>
                        ) : (
                            linkContent
                        )}
                    </SLinkContainer>
                );
            })}
            <SDivider />
            <SecondaryLinks sidebarOpen={sidebarOpen} />
            <SDivider />
            <SocialLinks sidebarOpen={sidebarOpen} />

        </SSidebar>
    );
};

const SecondaryLinks = ({ sidebarOpen }) => {
    const { loginWithPopup, isAuthenticated, logout, user } = useAuth0();
    const { userProfile, loadingProfile } = useUser();

    const AUTH_DISABLED = false; // Cambiar a false para habilitar el login

    const handleAuthAction = async (label) => {
        if (AUTH_DISABLED) return;
        if (label === "Login" && !isAuthenticated) {
            await loginWithPopup();
        } else if (label === "Logout" && isAuthenticated) {
            logout({ logoutParams: { returnTo: window.location.origin } });
        }
    };

    const isAdmin = userProfile?.roles?.includes('admin');

    const authLinks = isAuthenticated
        ? [
            {
                label: "Logout",
                icon: <MdLogout />,
            },
        ]
        : [
            {
                label: "Login",
                icon: <MdLogin />,
            },
        ];

    return (
        <>
            {isAuthenticated && user && (
                <SLinkContainer key="user-info">
                    <SLink to="/" style={{ width: "fit-content" }}>
                        <SLinkIcon><img src={user.picture} alt="User Avatar" style={{ borderRadius: "50%", maxWidth: "24px" }} /></SLinkIcon>
                        {sidebarOpen && <SLinkLabel>{user.name}</SLinkLabel>}
                    </SLink>
                </SLinkContainer>
            )}
            {isAuthenticated && !loadingProfile && isAdmin && (
                <SLinkContainer>
                    <SLink to="/config" style={!sidebarOpen ? { width: `fit-content` } : {}}>
                        <SLinkIcon>
                            <AiOutlineSetting />
                        </SLinkIcon>
                        {sidebarOpen && <SLinkLabel>Config</SLinkLabel>}
                    </SLink>
                </SLinkContainer>
            )}
            {authLinks.map(({ icon, label }) => {
                const linkContent = (
                    <SLinkContainer key={label} onClick={() => handleAuthAction(label)} style={AUTH_DISABLED ? { opacity: 0.5 } : {}}>
                        <SLink to="#" style={{ width: "fit-content", ...(AUTH_DISABLED ? { pointerEvents: 'none' } : {}) }}>
                            <SLinkIcon>{icon}</SLinkIcon>
                            {sidebarOpen && <SLinkLabel>{label}</SLinkLabel>}
                        </SLink>
                    </SLinkContainer>
                );
                return AUTH_DISABLED ? (
                    <Tooltip key={label} title="Próximamente" placement="right">
                        <div style={{ cursor: 'not-allowed' }}>{linkContent}</div>
                    </Tooltip>
                ) : linkContent;
            })}
        </>
    );
}

const linksArray = [
    {
        label: "Home",
        icon: <AiOutlineHome />,
        to: "/",
        notification: 0,
    },
    {
        label: "Torneos",
        icon: <AiOutlineTrophy />,
        to: "/tournaments",
        notification: 0,
    },
    {
        label: "Ranking",
        icon: <GoGraph />,
        to: "/ranking",
        notification: 0,
    },
    {
        label: "Clases",
        icon: <MdSchool />,
        to: "/clases",
        notification: 0,
    },
    {
        label: "Noticias",
        icon: <FaRegNewspaper />,
        to: "/news",
        notification: 0,
        disabled: true,
    },
];

const socialLinksArray = [
    {
        label: "Facebook",
        icon: <FaFacebook style={{ color: '#1877f2' }} />,
        href: "https://www.facebook.com/groups/171312706335911"
    },
    {
        label: "Instagram",
        icon: <FaInstagram style={{ color: '#c13584' }} />,
        href: "https://www.instagram.com/club.ajedrez.pensado/"
    }
];

const SocialLinks = ({ sidebarOpen }) => {
    return (
        <>
            {socialLinksArray.map(({ icon, label, href }) => {
                const linkContent = (
                    <SLink
                        as="a"
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={!sidebarOpen ? { width: `fit-content` } : {}}
                    >
                        <SLinkIcon>{icon}</SLinkIcon>
                        {sidebarOpen && <SLinkLabel>{label}</SLinkLabel>}
                    </SLink>
                );
                return (
                    <SLinkContainer key={label}>
                        {linkContent}
                    </SLinkContainer>
                );
            })}
        </>
    );
};

export default Sidebar;
